import React from 'react';

/**
 * A component for creating horizontal form layouts
 */
const FormRow = ({ 
  children, 
  className = '',
  cols = 2, // Number of columns: 1, 2, 3, or 4
  gap = 4, // Gap between columns: 2, 4, 6, or 8
  alignItems = 'start', // start, center, end
}) => {
  // Map cols to grid columns
  const colsMap = {
    1: 'grid-cols-1',
    2: 'grid-cols-1 md:grid-cols-2',
    3: 'grid-cols-1 md:grid-cols-3',
    4: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4',
  };
  
  // Map gap to Tailwind gap classes
  const gapMap = {
    2: 'gap-2',
    4: 'gap-4',
    6: 'gap-6',
    8: 'gap-8',
  };
  
  // Map alignItems to Tailwind classes
  const alignMap = {
    'start': 'items-start',
    'center': 'items-center',
    'end': 'items-end',
  };
  
  return (
    <div 
      className={`grid ${colsMap[cols] || colsMap[2]} ${gapMap[gap] || gapMap[4]} ${alignMap[alignItems] || alignMap['start']} ${className}`}
    >
      {children}
    </div>
  );
};

export default FormRow; 